<template>
  <h1>{{ bookCode }}</h1>
</template>

<script>
/* eslint-disable */

import service from "@/service/service";

var data = {
  busy: false,
  bookCode: null,
  book: null
}

export default {
  name: "Done",
  data() {
    return data
  },
  props: {
    // Ebook.code
    c: {
      type: String,
      required: true,      
      default: ""
    }    
  },
  created() {
    this.bookCode = this.c || this.$route.query.c || null
    this.busy = true

    service
      .getBook(this.bookCode)
      .then(
        (res => {
          console.log(`back from getBook`);
          if (this.debug) console.log(res);
          if (res.status) {
            this.book = res.book
            this.form.hash = this.book.hash
            this.jobTitles = res.jobTitles
          }
          else {
            this.error = true
          }
        }).bind(this)
      )
      .finally(e => {
        this.loading = false;
        console.log(`finally...`)
      })
      .catch(e => {
        this.error = true;
        console.log(e)
      });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Done.vue